import { Trophy, Sparkles } from "lucide-react";

/**
 * InboxXpBar — weekly Inbox-Zero-Hero progress. Reviewing 10 rows in
 * 7 days unlocks the "Inbox Zero Hero" badge. Extracted from
 * TransactionsInbox.jsx in iter-47.
 */
export default function InboxXpBar({ xp, justEarned, t }) {
  if (!xp) return null;
  return (
    <div
      className="mt-4 p-3 rounded-xl border"
      style={{
        borderColor: xp.badge_earned ? "rgba(45,90,64,0.35)" : "rgba(224,158,80,0.28)",
        background: xp.badge_earned
          ? "linear-gradient(120deg, rgba(45,90,64,0.10) 0%, rgba(123,196,144,0.08) 100%)"
          : "rgba(255,255,255,0.4)",
      }}
      data-testid="inbox-xp-bar"
    >
      <div className="flex items-center justify-between gap-3 mb-2 flex-wrap">
        <div className="flex items-center gap-2 text-xs font-medium text-[var(--text-primary)]">
          {xp.badge_earned
            ? <Trophy size={13} className="text-[var(--accent-primary)]"/>
            : <Sparkles size={13} className="text-[#A16A25]"/>
          }
          <span data-testid="inbox-xp-label">
            {xp.badge_earned
              ? t("inbox.xp_earned_label", { count: xp.reviewed_this_week })
              : t("inbox.xp_progress_label", { reviewed: xp.reviewed_this_week, target: xp.target })}
          </span>
        </div>
        {justEarned && (
          <span
            className="text-[10px] font-medium tracking-wider uppercase px-2 py-0.5 rounded-full"
            style={{ background: "rgba(45,90,64,0.18)", color: "#2D5A40" }}
          >
            {t("inbox.just_earned")}
          </span>
        )}
      </div>
      <div className="h-1.5 w-full rounded-full overflow-hidden bg-[var(--bg-accent)]">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${xp.pct}%`,
            background: xp.badge_earned
              ? "linear-gradient(90deg, #2D5A40 0%, #7BC490 100%)"
              : "linear-gradient(90deg, #E09E50 0%, #A16A25 100%)",
          }}
          data-testid="inbox-xp-progress-fill"
        />
      </div>
    </div>
  );
}
